<template>
  <div class="space-top-desktop">
    <h1 style="text-align: center">Passagem</h1>
    <b-row style="margin-top: 50px; align-items: center; justify-content: center">
      <b-col sm="12" md="6">
        <p>
          As grades SIBROL são amplamente utilizadas em passagem de veículos aumentando assim a agilidade e praticidade nos serviços executados na indústria automobilística.
        </p>
      </b-col>
      <b-col sm="12" md="6">
        <img src="@/assets/images/img_grade15.jpg" alt="img" class="sec-img w-100 img-shadow-blue img-fluid" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Passagem",
};
</script>
